<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In / Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="show-absatz"
                                           v-model="config.showAbsatz">
                                    <label class="form-check-label" for="show-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="show-umsatz"
                                           v-model="config.showUmsatz">
                                    <label class="form-check-label" for="show-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Konfiguration</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellInOut.mode']"></i>
                            <b>Modus</b>
                        </label>
                        <select class="form-control" v-model="config.mode">
                            <option value="in:all-split">Sell-In: Anbieter und Großhandel - Getrennt</option>
                            <option value="in:all-sum">Sell-In: Anbieter und Großhandel - Summe</option>
                            <option value="in:anbieter">Sell-In: Anbieter</option>
                            <option value="in:grosshandel">Sell-In: Großhandel</option>
                            <option value="out">Sell-Out</option>
                        </select>
                        <div class="form-check mt-2" v-if="config.mode !== 'in:all-sum' && config.mode !== 'out'">
                            <input class="form-check-input" type="checkbox" value="" id="mode-switch"
                                   v-model="config.sellInModeSwitch">
                            <label class="form-check-label" for="mode-switch">
                                Überweiser in Direktgeschäft
                            </label>
                        </div>
                        <div class="form-check mt-2">
                            <input class="form-check-input" type="checkbox" value="" id="bonus-steigerung"
                                   v-model="config.bonusOnSteigerung">
                            <label class="form-check-label" for="bonus-steigerung">
                                Ausschüttung Apotheken nur bei Umsatzsteigerung
                            </label>
                        </div>
                    </div>
                </fieldset>

                <div class="row" v-if="config.mode.startsWith('in:')">
                    <div class="col">
                        <fieldset class="border px-3 mb-3">
                            <legend class="w-auto">{{ sellInHeaders[0] }}</legend>

                            <div class="form-group">
                                <label><b>Umsatz Basis</b></label>
                                <select class="form-control" v-model="config.sellIn1Base">
                                    <option value="listenek">Listen EK</option>
                                    <option value="nettoek">Netto EK</option>
                                    <option value="listenvk">Listen VK</option>
                                    <option value="kalkuliertervk">Kalkulierter VK</option>
                                </select>
                            </div>

                            <div class="form-check my-2" v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn1Base)">
                                <input class="form-check-input" type="checkbox" value="" id="sell-in-1-tax"
                                       v-model="config.sellIn1RemoveTax">
                                <label class="form-check-label" for="sell-in-1-tax">
                                    Mwst. herausrechnen
                                </label>
                            </div>

                            <div class="form-group">
                                <label><b>Pauschalkondition abziehen</b></label>
                                <select class="form-control" v-model="config.sellIn1Condition">
                                    <option :value="false">Nein</option>
                                    <option :value="true">Ja</option>
                                </select>
                                <div class="input-group mt-2" v-if="config.sellIn1Condition">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Prozent</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="5" v-model="config.sellIn1ConditionPercent">
                                </div>
                            </div>

                            <tiers-module :dto="config.sellIn1Tiers"></tiers-module>
                        </fieldset>
                    </div>
                    <div class="col" v-if="sellInHeaders.length > 1">
                        <fieldset class="border px-3 mb-3">
                            <legend class="w-auto">{{ sellInHeaders[1] }}</legend>

                            <div class="form-group">
                                <label><b>Umsatz Basis</b></label>
                                <select class="form-control" v-model="config.sellIn2Base">
                                    <option value="listenek">Listen EK</option>
                                    <option value="nettoek">Netto EK</option>
                                    <option value="listenvk">Listen VK</option>
                                    <option value="kalkuliertervk">Kalkulierter VK</option>
                                </select>
                            </div>

                            <div class="form-check my-2" v-if="['listenvk', 'kalkuliertervk'].includes(config.sellIn2Base)">
                                <input class="form-check-input" type="checkbox" value="" id="sell-in-2-tax"
                                       v-model="config.sellIn2RemoveTax">
                                <label class="form-check-label" for="sell-in-2-tax">
                                    Mwst. herausrechnen
                                </label>
                            </div>

                            <div class="form-group">
                                <label><b>Pauschalkondition abziehen</b></label>
                                <select class="form-control" v-model="config.sellIn2Condition">
                                    <option :value="false">Nein</option>
                                    <option :value="true">Ja</option>
                                </select>
                                <div class="input-group mt-2" v-if="config.sellIn2Condition">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Prozent</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="5" v-model="config.sellIn2ConditionPercent">
                                </div>
                            </div>

                            <tiers-module :dto="config.sellIn2Tiers"></tiers-module>

                        </fieldset>
                    </div>
                </div>

                <fieldset class="border px-3 mb-3" v-if="config.mode === 'out'">
                    <legend class="w-auto">Sell Out</legend>

                    <div class="form-group">
                        <label><b>Umsatz Basis</b></label>
                        <select class="form-control" v-model="config.sellOutBase">
                            <option value="listenek">Listen EK</option>
                            <option value="nettoek">Netto EK</option>
                            <option value="listenvk">Listen VK</option>
                            <option value="listenvkfallback">Listen VK (Fallback)</option>
                            <option value="tatsaechlichervk">Netto VK</option>
                        </select>
                    </div>

                    <div class="form-check my-2" v-if="['listenvk', 'listenvkfallback', 'tatsaechlichervk'].includes(config.sellOutBase)">
                        <input class="form-check-input" type="checkbox" value="" id="sell-out-tax"
                               v-model="config.sellOutRemoveTax">
                        <label class="form-check-label" for="sell-out-tax">
                            Mwst. herausrechnen
                        </label>
                    </div>

                    <div class="form-group">
                        <label><b>Pauschalkondition abziehen</b></label>
                        <select class="form-control" v-model="config.sellOutCondition">
                            <option :value="false">Nein</option>
                            <option :value="true">Ja</option>
                        </select>
                        <div class="input-group mt-2" v-if="config.sellOutCondition">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="5" v-model="config.sellOutConditionPercent">
                        </div>
                    </div>

                    <tiers-module :dto="config.sellOutTiers"></tiers-module>
                </fieldset>

                <fieldset class="border px-3" v-if="!(options.disabledFeatures || []).includes('panel_settings')">
                    <legend class="w-auto">Prozentregelung</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPercent']"></i>
                            <b>Panelgröße</b>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPeriod']"></i>
                            <b>Startdatum Modus</b>
                        </label>
                        <select class="form-control" v-model="config.panelPeriod">
                            <option value="full">Gesamtzeitraum</option>
                            <option value="quarterly-start">Quartalsweise - Anfang</option>
                            <option value="quarterly-middle">Quartalsweise - Mitte</option>
                            <option value="quarterly-end">Quartalsweise - Ende</option>
                            <option value="monthly">Monatlich</option>
                        </select>
                    </div>

                    <div class="form-check my-2" v-if="config.mode === 'in:all-split'">
                        <input class="form-check-input" type="checkbox" value="" id="panel-combine-blocks"
                               v-model="config.panelCombineBlocks">
                        <label class="form-check-label" for="panel-combine-blocks">
                            Blöcke für Umsatzfaktor kombinieren
                        </label>
                    </div>
                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering" :options="options"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../Modules/TimingPeriodModule";
import FilteringModule from "../Modules/FilteringModule";
import TiersModule from "../Modules/TiersModule";

export default {
    components: {TiersModule, FilteringModule, TimingPeriodModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto
        };
    },
    computed: {
        sellInHeaders() {
            const headers = [];
            if (this.config.mode === 'in:all-sum') {
                headers.push('Sell-In');
            }
            if (this.config.mode === 'in:all-split') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Sell-In Direkt & Überweiser');
                    headers.push('Sell-In Großhandel');
                } else {
                    headers.push('Sell-In Direkt');
                    headers.push('Sell-In Großhandel');
                }
            }
            if (this.config.mode === 'in:anbieter') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Sell-In Direkt & Überweiser');
                } else {
                    headers.push('Sell-In Direkt');
                }
            }
            if (this.config.mode === 'in:grosshandel') {
                if (this.config.sellInModeSwitch) {
                    headers.push('Sell-In Großhandel ohne Überweiser');
                } else {
                    headers.push('Sell-In Großhandel');
                }
            }

            return headers;
        }
    }
}
</script>
